export const HIDE_SERVICE = false

export const cvPath = '/assets/vivekpadelkar-cv.pdf'

export const frontendSkills = [
  {
    skill: 'React',
    expLevel: 'Experienced',
  },
  {
    skill: 'HTML',
    expLevel: 'Experienced',
  },
  {
    skill: 'CSS',
    expLevel: 'Intermediate',
  },
  {
    skill: 'Bootstrap',
    expLevel: 'Intermediate',
  },
  {
    skill: 'AWS',
    expLevel: 'Beginner',
  },
  {
    skill: 'JavaScript',
    expLevel: 'Experienced',
  },
  {
    skill: '.Net (c#,vb.Net,VBA)',
    expLevel: 'Experienced',
  },
]

export const backendSkills = [
  {
    skill: 'PostgreSQL',
    expLevel: 'Intermediate',
  },
  {
    skill: 'MongoDB',
    expLevel: 'Intermediate',
  },
  {
    skill: 'Microsoft SQL Server',
    expLevel: 'Experienced',
  },
  {
    skill: 'MySQL',
    expLevel: 'Experienced',
  },
]

export const projecdetails = [
  {
    name: 'MeShop',
    imagepath: '/assets/meshop.jpg',
    projecturl: 'https://meshop-live.herokuapp.com/',
  },
  {
    name: 'bepbahong',
    imagepath: '/assets/quan_dau16.jpg',
    projecturl: 'https://bepbahong.herokuapp.com/',
  },
  {
    name: 'Amazon-clone',
    imagepath: '/assets/amazon_clone.png',
    projecturl: 'https://amzon-react-clone.herokuapp.com/',
  },
  {
    name: 'Tesla-clone',
    imagepath: '/assets/tesla_clone.jpg',
    projecturl: 'https://vivek-padelkar.github.io/tesla-clone/',
  },
  {
    name: 'noddleshopie',
    imagepath: '/assets/noodleShopie.png',
    projecturl: 'https://noddleshopie.netlify.app/',
  },
  {
    name: 'Monster rolodex',
    imagepath: '/assets/monster_rolodex.jpg',
    projecturl: 'https://vivek-padelkar.github.io/monster-rolodex/',
  },
]

export const achivement = [
  {
    name: 'Complete React Developer',
    desc: 'Completed the course "Complete React Developer in 2022 (w/ Redux, Hooks, GraphQL)" on 03/09/2022 as taught by Andrei Neagoie, Yihua Zhang, Zero To Mastery on Udemy.',
    imagepath: '/assets/react_cetificate.jpg',
  },
]

export const clientTestimonial = {
  name: 'Mae Hong',
  review:
    'I am really impressed by the quality of services I received from Vivek. You were right on schedule, charged reasonable prices, were professional and courteous in dealings, and delivered items well before time. I have got a good e-commerce site for my products. My revenue has increased because of bepbahong and I will definitely use his services again.',
}

export const companies = ['tantrasoftosolution', 'greysoft', 'mphasis']
